import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6f092d37")
const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = { ref: "c" }
const _hoisted_3 = { class: "play" }
const _hoisted_4 = {
  key: 0,
  class: "ripple"
}
const _hoisted_5 = {
  key: 0,
  class: "timeTaken"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Escaped", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 7 minutes and 28 seconds")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "popup one"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "h" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon _img" }),
  /*#__PURE__*/_createElementVNode("div", null, "Wikipedia")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode("Florence ... is the most populated city in "),
  /*#__PURE__*/_createElementVNode("b", null, "Tuscany"),
  /*#__PURE__*/_createTextVNode("...")
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "popup two"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "h" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon _img" }),
  /*#__PURE__*/_createElementVNode("div", null, "Maps")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "map _img" }, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "popup three"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "h" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon _img" }),
  /*#__PURE__*/_createElementVNode("div", null, "The stone tablet")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Avventurati dall'Oltrarno e scopri la struttura più antica. Come si chiama?", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "img _img" }, null, -1)
const _hoisted_22 = { class: "text" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "We'll always have...")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Florence, the most populated city in what region?")
], -1)
const _hoisted_25 = { class: "input" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "img _img one" }, null, -1)
const _hoisted_27 = { class: "text" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Atop the city")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "San Miniato al Monte overlooks what quarter?")
], -1)
const _hoisted_30 = { class: "input" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass({i:true, pdf:true, _img:true})
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, "The stone tablet", -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "file" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "i download _img" }),
  /*#__PURE__*/_createElementVNode("div", null, "A nonsense whisper")
], -1)
const _hoisted_35 = { class: "text" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Built in the wall")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "You are pulled aside by a strange figure - they point to the wall where you find something mounted - a stone tablet! He whispers something to you, but is it nonsense?")
], -1)
const _hoisted_38 = { class: "input" }
const _hoisted_39 = {
  key: 7,
  class: /*#__PURE__*/_normalizeClass({
      card:true, four:true, 
    })
}
const _hoisted_40 = { class: "img" }
const _hoisted_41 = { class: "text" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "It's sunken beneath")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Everything points towards a nearby body of water. But what?")
], -1)
const _hoisted_44 = { class: "input" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Room = _resolveComponent("Room")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", _hoisted_2, null, 512),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass({icon:true,expand:_ctx.stage>1,_img:true})
      }, null, 2),
      (_ctx.stage>1&&_ctx.stage<3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    (_ctx.stage>14)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "player one _img",
      style: _normalizeStyle(
      _ctx.stage==3?'transform:translate3d(122px, 314px, 0px)'
      :_ctx.stage==4?'transform:translate3d(338px, 370px, 0px)'
      :_ctx.stage>12?'transform:translate3d(370px, 190px, 0px)'
      :'transform:translate3d(-30px,30px,0px)'
    )
    }, null, 4),
    _createElementVNode("div", {
      class: "player two _img",
      style: _normalizeStyle(
      _ctx.stage==5?'transform:translate3d(125px, 65px, 0px)'
      :_ctx.stage==6?'transform:translate3d(338px, 345px, 0px)'
      :_ctx.stage>10?'transform:translate3d(368px, -30px, 0px)'
      :'transform:translate3d(-30px,30px,0px)'
    )
    }, null, 4),
    _createElementVNode("div", {
      class: "player three _img",
      style: _normalizeStyle(
      _ctx.stage==8?'transform:translate3d(120px, 23px, 0px)'
      :_ctx.stage==9?'transform:translate3d(370px, 124px, 0px)'
      :_ctx.stage==10?'transform:translate3d(338px, 310px, 0px)'
      :_ctx.stage>10?'transform:translate3d(368px, -30px, 0px)'
      :'transform:translate3d(-30px,30px,0px)'
    )
    }, null, 4),
    _createElementVNode("div", {
      class: "player four _img",
      style: _normalizeStyle(
      _ctx.stage>10?'transform:translate3d(338px, 300px, 0px)'
      :'transform:translate3d(-30px,30px,0px)'
    )
    }, null, 4),
    _createElementVNode("div", {
      class: "player five _img",
      style: _normalizeStyle(
      _ctx.stage>11?'transform:translate3d(-70px, 278px, 0px)'
      :'transform:translate3d(-30px,30px,0px)'
    )
    }, null, 4),
    (_ctx.stage>2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.stage>5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
      : _createCommentVNode("", true),
    (_ctx.stage>8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
      : _createCommentVNode("", true),
    (_ctx.stage>1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass({
      card:true, one:true, 
      moveStepOne:_ctx.stage>4,
      moveStepTwo:_ctx.stage>6,
      moveStepThree:_ctx.stage>10,
    })
        }, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.guessOne), 1)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.stage>4)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: _normalizeClass({
      card:true, two:true, 
      moveStepOne:_ctx.stage>6,
      moveStepTwo:_ctx.stage>10,
    })
        }, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.guessTwo), 1)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.stage>6)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: _normalizeClass({
      card:true, two:true, file:true,
      moveStepOne:_ctx.stage>10
    })
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass({file:true,pulse:_ctx.stage==9})
            }, _hoisted_33, 2),
            _hoisted_34
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.guessThree), 1)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.stage>10)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_Room, {
              rotatable: true,
              slowRotate: true,
              properties: _ctx.doorRoomData,
              escaped: _ctx.escaped,
              onEscaped: _cache[0] || (_cache[0] = ($event: any) => (_ctx.escaped=true))
            }, null, 8, ["properties", "escaped"])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.guessFour), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}